import { useNavigate } from "react-router-dom";
import { Get_Package_Type } from "../Model/HomeModel";

export default function PackageCard({
  el,
  Styles,
  setEnrollActive,
  setCourseId,
}) {
  const Navigate = useNavigate();
  const Package_Type = Get_Package_Type(el?.PackageType);

  return (
    <div className="Mobile_View_css Desktop_Card">
      <div className="course-card-new">
        <div className="course-image">
          <img src={el?.Image} alt="Students studying" />
          <div
            className={`course-badge ${Package_Type?.name}`}
            style={{ backgroundColor: Package_Type?.color }}
          >
            {" "}
            {Package_Type?.name}
          </div>
          <div className="course-duration">{el?.Duration} Weeks</div>
        </div>
        <div className="course-content">
          <h3> {el?.Name}</h3>
          <div className="course-features">
            {el?.LIVE_CLASSES ? (
              <div className="feature">
                <img
                  src="/assets/image/ProductCard-Icon/icon_LIVE_CLASSES.svg"
                  alt="icon_LIVE_CLASSES"
                />

                <span>{el?.LIVE_CLASSES} LIVE CLASSES </span>
              </div>
            ) : (
              ""
            )}

            {el?.One_On_One_DOUBT_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
                    alt="icon_LIVE_CLASSES"
                  />
                </span>
                <span>1:1 DOUBT SESSIONS </span>
              </div>
            ) : (
              ""
            )}

            {el?.DOUBT_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
                    alt="icon_LIVE_CLASSES"
                  />
                </span>
                <span> DOUBT SESSIONS</span>
              </div>
            ) : (
              ""
            )}
            {el?.SESSION_TESTS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_SESSION_TESTS.svg"
                    alt="icon_SESSION_TESTS"
                  />
                </span>
                <span>SESSION TESTS </span>
              </div>
            ) : (
              ""
            )}
            {el?.STUDY_MATERIAL_ACCESS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_STUDY_MATERIAL_ACCESS.svg"
                    alt="icon_STUDY_MATERIAL_ACCESS"
                  />
                </span>
                <span> STUDY MATERIAL ACCESS</span>
              </div>
            ) : (
              ""
            )}

            {el?.COMPLETE_MOCK_TEST ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_MOCK_TEST.svg"
                    alt="icon_MOCK_TEST"
                  />
                </span>
                <span>{el?.COMPLETE_MOCK_TEST} COMPLETE MOCK TEST</span>
              </div>
            ) : (
              ""
            )}

            {el?.COMPLETE_MOCK_TEST_AI ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_MOCK_TEST_AI.svg"
                    alt="icon_MOCK_TEST"
                  />
                </span>
                <span>
                  {el?.COMPLETE_MOCK_TEST_AI} COMPLETE MOCK TEST (POWERED BY AI)
                </span>
              </div>
            ) : (
              ""
            )}
            {el?.TESTIFYI_REALITY_TEST ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_reality_test.svg"
                    alt="icon_reality_test"
                  />
                </span>
                <span> {el?.TESTIFYI_REALITY_TEST} TESTIFYI REALITY TEST</span>
              </div>
            ) : (
              ""
            )}

            {el?.MASTER_CLASS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Master_class.svg"
                    alt="icon_Master_class"
                  />
                </span>
                <span>MASTER CLASS</span>
              </div>
            ) : (
              ""
            )}

            {el?.One_On_One_SPEAKING_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Speaking_Session.svg"
                    alt="icon_Speaking_Session"
                  />
                </span>
                <span>1:1 SPEAKING SESSIONS</span>
              </div>
            ) : (
              ""
            )}

            {el?.LANGUAGE_PRACTICE_TEST ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_LANGUAGE_PRACTICE_TEST.svg"
                    alt="icon_LANGUAGE_PRACTICE_TEST"
                  />
                </span>
                <span>{el?.LANGUAGE_PRACTICE_TEST} TESTIFYI PRACTICE TEST</span>
              </div>
            ) : (
              ""
            )}

            {el?.GRAMMAR_TEST === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_GRAMMAR_TEST.svg"
                    alt="icon_GRAMMAR_TEST"
                  />
                </span>
                <span>GRAMMAR TEST</span>
              </div>
            ) : (
              ""
            )}

            {el?.MOCK_INTERVIEW === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Mock_INTERVIEW.svg"
                    alt="icon_Mock_INTERVIEW"
                  />
                </span>
                <span>MOCK INTERVIEW</span>
              </div>
            ) : (
              ""
            )}

            {el?.GROUP_DISCUSSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_GROUP_DISCUSSIONS.svg"
                    alt="icon_GROUP_DISCUSSIONS"
                  />
                </span>
                <span>GROUP DISCUSSIONS</span>
              </div>
            ) : (
              ""
            )}

            {el?.BUSINESS_ENGLISH_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_BUSINESS_ENGLISH_SESSIONS.svg"
                    alt="icon_BUSINESS_ENGLISH_SESSIONS"
                  />
                </span>
                <span>BUSINESS ENGLISH SESSIONS</span>
              </div>
            ) : (
              ""
            )}

            {el?.SOFT_SKILLS_SESSION === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_SOFT_SKILLS_SESSION.svg"
                    alt="icon_SOFT_SKILLS_SESSION"
                  />
                </span>
                <span>SOFT SKILLS SESSION</span>
              </div>
            ) : (
              ""
            )}

            {el?.EXPERT_SESSIONS === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_LIVE_CLASSES.svg"
                    alt="icon_EXPERT_SESSIONS"
                  />
                </span>
                <span> EXPERT SESSIONS</span>
              </div>
            ) : (
              ""
            )}

            {el?.WEEKLY_DOUBT_SESSION === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_Speaking_Session.svg"
                    alt="icon_WEEKLY_DOUBT_SESSION"
                  />
                </span>
                <span>WEEKLY DOUBT SESSION</span>
              </div>
            ) : (
              ""
            )}

            {el?.STUDY_MATERIAL === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_STUDY_MATERIAL_ACCESS.svg"
                    alt="icon_STUDY_MATERIAL"
                  />
                </span>
                <span>STUDY MATERIAL</span>
              </div>
            ) : (
              ""
            )}

            {el?.PRACTICE_PORTAL === "Yes" ? (
              <div className="feature">
                <span>
                  <img
                    src="/assets/image/ProductCard-Icon/icon_SESSION_TESTS.svg"
                    alt="icon_PRACTICE_PORTAL"
                  />
                </span>
                <span>PRACTICE PORTAL</span>
              </div>
            ) : (
              ""
            )}
          </div>

          {el?.DiscountedPrice ? (
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <div className="course-price">₹ {el?.DiscountedPrice} /-</div>
              <p className={Styles.LineThrough}>₹ {el?.ActualCost} /- </p>
            </div>
          ) : (
            <div>
              <div className="course-price">₹ {el?.ActualCost} /-</div>
              <p> </p>
            </div>
          )}
          {/* <div className="course-price">₹9,999/-</div> */}
          <div className="course-actions">
            <button
              className="btn-outline"
              onClick={() => Navigate(`/Course/details/${el?._id}`)}
            >
              View
            </button>
            <button
              className="btn-primary"
              onClick={() => {
                setEnrollActive(el?._id);
                setCourseId(el?.CourseId);
              }}
            >
              Enroll Now
            </button>
          </div>
        </div>
      </div>
    </div>
    // ) : (
    //   <>
    //     <div key={el?._id} className={Styles.card_design}>
    //       <div
    //         style={{ backgroundImage: `url(${el?.Image})` }}
    //         className={`${Styles.Card1} ${Styles.Card1_Img}`}
    //       >
    //         <div>
    //           {/* <button>Speaking</button> */}
    //           <button style={{ backgroundColor: Package_Type?.color }}>
    //             {Package_Type?.name}
    //           </button>{" "}
    //         </div>
    //       </div>
    //       <div>
    //         <div>
    //           <p>
    //             Duration:
    //             <span style={{ color: "#0b3eff" }}>
    //               {" "}
    //               {el?.Duration} Weeks
    //             </span>{" "}
    //           </p>
    //           <p style={{ fontSize: "19px", fontWeight: "600" }}>
    //             {el?.Name}
    //             {/* Speaking & Writing <br /> Intermediate Package 003 */}
    //           </p>
    //         </div>
    //         <hr />
    //         <div>
    //           <p>
    //             <strong>This package Includes : </strong>
    //           </p>
    //           <div className={Styles.SpeakingWriting}>
    //             {el?.LIVE_CLASSES ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_LIVE_CLASSES.svg"
    //                     alt="icon_LIVE_CLASSES"
    //                   />
    //                 </span>
    //                 <span>{el?.LIVE_CLASSES} LIVE CLASSES </span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.One_On_One_DOUBT_SESSIONS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
    //                     alt="icon_LIVE_CLASSES"
    //                   />
    //                 </span>
    //                 <span>1:1 DOUBT SESSIONS </span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.DOUBT_SESSIONS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
    //                     alt="icon_LIVE_CLASSES"
    //                   />
    //                 </span>
    //                 <span> DOUBT SESSIONS</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}
    //             {el?.SESSION_TESTS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_SESSION_TESTS.svg"
    //                     alt="icon_SESSION_TESTS"
    //                   />
    //                 </span>
    //                 <span>SESSION TESTS </span>
    //               </p>
    //             ) : (
    //               ""
    //             )}
    //             {el?.STUDY_MATERIAL_ACCESS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_STUDY_MATERIAL_ACCESS.svg"
    //                     alt="icon_STUDY_MATERIAL_ACCESS"
    //                   />
    //                 </span>
    //                 <span> STUDY MATERIAL ACCESS</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.COMPLETE_MOCK_TEST ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_MOCK_TEST.svg"
    //                     alt="icon_MOCK_TEST"
    //                   />
    //                 </span>
    //                 <span>{el?.COMPLETE_MOCK_TEST} COMPLETE MOCK TEST</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.COMPLETE_MOCK_TEST_AI ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_MOCK_TEST_AI.svg"
    //                     alt="icon_MOCK_TEST"
    //                   />
    //                 </span>
    //                 <span>
    //                   {el?.COMPLETE_MOCK_TEST_AI} COMPLETE MOCK TEST (POWERED BY
    //                   AI)
    //                 </span>
    //               </p>
    //             ) : (
    //               ""
    //             )}
    //             {el?.TESTIFYI_REALITY_TEST ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_reality_test.svg"
    //                     alt="icon_reality_test"
    //                   />
    //                 </span>
    //                 <span>
    //                   {" "}
    //                   {el?.TESTIFYI_REALITY_TEST} TESTIFYI REALITY TEST
    //                 </span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.MASTER_CLASS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_Master_class.svg"
    //                     alt="icon_Master_class"
    //                   />
    //                 </span>
    //                 <span>MASTER CLASS</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.One_On_One_SPEAKING_SESSIONS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_Speaking_Session.svg"
    //                     alt="icon_Speaking_Session"
    //                   />
    //                 </span>
    //                 <span>1:1 SPEAKING SESSIONS</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.LANGUAGE_PRACTICE_TEST ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_LANGUAGE_PRACTICE_TEST.svg"
    //                     alt="icon_LANGUAGE_PRACTICE_TEST"
    //                   />
    //                 </span>
    //                 <span>
    //                   {el?.LANGUAGE_PRACTICE_TEST} TESTIFYI PRACTICE TEST
    //                 </span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.GRAMMAR_TEST === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_GRAMMAR_TEST.svg"
    //                     alt="icon_GRAMMAR_TEST"
    //                   />
    //                 </span>
    //                 <span>GRAMMAR TEST</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.MOCK_INTERVIEW === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_Mock_INTERVIEW.svg"
    //                     alt="icon_Mock_INTERVIEW"
    //                   />
    //                 </span>
    //                 <span>MOCK INTERVIEW</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.GROUP_DISCUSSIONS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_GROUP_DISCUSSIONS.svg"
    //                     alt="icon_GROUP_DISCUSSIONS"
    //                   />
    //                 </span>
    //                 <span>GROUP DISCUSSIONS</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.BUSINESS_ENGLISH_SESSIONS === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_BUSINESS_ENGLISH_SESSIONS.svg"
    //                     alt="icon_BUSINESS_ENGLISH_SESSIONS"
    //                   />
    //                 </span>
    //                 <span>BUSINESS ENGLISH SESSIONS</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}

    //             {el?.SOFT_SKILLS_SESSION === "Yes" ? (
    //               <p>
    //                 <span>
    //                   <img
    //                     src="/assets/image/ProductCard-Icon/icon_SOFT_SKILLS_SESSION.svg"
    //                     alt="icon_SOFT_SKILLS_SESSION"
    //                   />
    //                 </span>
    //                 <span>SOFT SKILLS SESSION</span>
    //               </p>
    //             ) : (
    //               ""
    //             )}
    //           </div>
    //         </div>
    //         <hr />
    //         <div className={Styles.Card_Menu}>
    //           {el?.DiscountedPrice ? (
    //             <div>
    //               <p className={Styles.ActualCost}>₹ {el?.DiscountedPrice} /-</p>
    //               <p className={Styles.LineThrough}>₹ {el?.ActualCost} /- </p>
    //             </div>
    //           ) : (
    //             <div>
    //               <p className={Styles.ActualCost}>₹ {el?.ActualCost} /-</p>
    //               <p> </p>
    //             </div>
    //           )}
    //           <div>
    //             <button onClick={() => Navigate(`/Course/details/${el?._id}`)}>
    //               View
    //             </button>
    //             <button
    //               onClick={() => {
    //                 setEnrollActive(el?._id);
    //                 setCourseId(el?.CourseId);
    //               }}
    //             >
    //               Enroll Now
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </>
  );
}
